import {
	hasSubmission,
	type FormPair,
} from '@dealstack/frontend/investor/pages/Investment/common/InvestorKycFormsTable/types';

/**
 * The file to hand over as the blank form to fill in. Before a submission the instance file is
 * either the template or its pre-filled copy — both are what the investor should get. Once they
 * have submitted, the instance file is their own upload, so a clean copy has to come from the
 * template.
 */
export const cleanCopyFileId = (form: FormPair): string =>
	hasSubmission(form) ? form.templateFileId : form.fileId ?? form.templateFileId;
